import {Field} from "../widgets"

const ModelAdmin = ({heading, record, fields}) => {

    return (
        <div className="details-editor">
            {!!heading && <h2>{heading} </h2>}
            <table>
                <colgroup>
                    <col span="1" style={{width: "15%"}} />
                    <col span="1" style={{width: "85%"}} />
                </colgroup>
                <tbody>
                    {fields.map(fld =>
                        <tr key={fld.name}>
                            <td style={{
                                fontWeight: "bold",
                                paddingRight: "10px",
                                textAlign: "right"
                            }}>{fld.label}</td>
                            <td>
                                <Field entity={record} fld={fld} />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default ModelAdmin